import React from 'react';
import PropTypes from 'prop-types';

import { Table } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHistory } from '@fortawesome/pro-solid-svg-icons';

import { patch, post } from 'helpers/api';
import RevertImportModal from './revert_import_modal';

export default class ImportsTable extends React.Component {
  static propTypes = {
    imports: PropTypes.arrayOf(PropTypes.object).isRequired,
    importsPath: PropTypes.string.isRequired,
  }

  state = {
    revertingImport: null
  };

  handleNewImport = () => {
    const { importsPath } = this.props;

    post(importsPath).then((response) => {
      window.location.href = response;
    });
  }

  handleRevertImport = () => {
    const { revertingImport } = this.state;

    patch(revertingImport.runPath, {
      importerRun: {
        status: "reverting"
      }
    }).then(() => {
      window.location.reload();
    });
  }

  handleStartRevertImport = importer => this.setState({ revertingImport: importer });
  handleCancelRevertImport = () => this.setState({ revertingImport: null });

  renderImportsRows() {
    const { imports } = this.props;

    return imports.map((importer) => {
      return (
        <tr key={importer.id}>
          <td>
            <a className="clickable" href={importer.importerPath}>{importer.name}</a>
          </td>
          <td>{importer.status}</td>
          <td>{importer.updatedAt}</td>
          <td>
            {importer.status === "Complete" &&
              <div className="text-danger clickable" onClick={() => this.handleStartRevertImport(importer)}>
                <FontAwesomeIcon className="mr-3" icon={faHistory} />
                Revert Import
              </div>
            }
          </td>
        </tr>
      );
    });
  }

  renderHeader() {
    return (
      <div className="pl-3">
        <div className="pt-3 d-inline-block">
          <span className="h2">
            Imports
          </span>
        </div>
        <div className="pull-right">
          <div className="btn btn-sm btn-create" onClick={this.handleNewImport}>
            New Import
          </div>
        </div>
      </div>
    );
  }

  renderImportsTable() {
    return (
      <Table className="imports-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Status</th>
            <th>Date</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {this.renderImportsRows()}
        </tbody>
      </Table>
    );
  }

  render() {
    const { imports } = this.props;
    const { revertingImport } = this.state;

    return (
      <div>
        {this.renderHeader()}
        {imports.length === 0 ?
          (<div className="pt-5 pl-3 text-muted">
            You have not performed any Imports. Please click "New Import" to import  your external data into Buildout.
          </div>)
          : this.renderImportsTable()
        }
        {revertingImport &&
          <RevertImportModal
            revertingImport={revertingImport}
            onCancelRevert={this.handleCancelRevertImport}
            onRevert={this.handleRevertImport}
          />
        }
      </div>
    );
  }
}
